// extracted by mini-css-extract-plugin
module.exports = {"pendingFlag":"Account_pendingFlag__1Kwrg","rejectionFlag":"Account_rejectionFlag__2trn4"};